import Text20 from './Text20'
export default Text20
